import axios from "axios";

const state = {
  currentCityPage: null,
  currentStatePage: null,
  loadingState: [],
  selectedCity: null,
  selectedState: null,
  cities: null,
  states: null,
  promoImgText: ""
};

const actions = {
  getAllStates: ({ state, commit }) => {
    return axios.get(`/locations/states`)
      .then((resp) => {
        commit("getAllStatesSuccess", resp.data);
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getAllCitiesForState: ({ state, commit }) => {
    return axios.get(`/locations/${state.selectedState}/cities`)
      .then((resp) => {
        commit("getAllCitiesForStateSuccess", resp.data);
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getStatePageContent: ({ commit, dispatch, state }) => {
    return axios.get(`/locations/${state.selectedState}`)
      .then((resp) => {
        dispatch("clearPromoImgAltText", "");
        commit("setCurrentStatePageData", resp.data.sections);
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getCityPageContent: ({ commit, dispatch, state }) => {
    return axios.get(`/locations/${state.selectedState}/${state.selectedCity}`)
      .then((resp) => {
        dispatch("clearPromoImgAltText", "");
        commit("setCurrentCityPageData", resp.data.sections);
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  updateStatePage: ({ state, dispatch }) => {
    return axios.patch(`/locations/${state.selectedState}`, state.currentStatePage)
      .then((resp) => {
        dispatch("clearPromoImgAltText", "");
        dispatch("snackbar/successMessage", `Successfully updated state page`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },

  updateCityPage: ({ state, dispatch }) => {
    return axios.patch(`/locations/${state.selectedState}/${state.selectedCity}`, state.currentCityPage)
      .then((resp) => {
        dispatch("clearPromoImgAltText", "");
        dispatch("snackbar/successMessage", `Successfully updated city page`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },

  selectCurrentState: ({ dispatch, commit }, value) => {
    commit("setCurrentState", value);
    commit("clearCurrentStatePageContent");
    dispatch("getStatePageContent", value);
  },

  selectCurrentCity: ({ dispatch, commit }, value) => {
    commit("setCurrentCity", value);
    commit("clearCurrentCityPageContent");
    dispatch("getCityPageContent", value);
  },

  uploadStatePromoImage: ({ state, dispatch }, formData) => {
    return axios.post(`/locations/${state.selectedState}/images`, formData)
      .then(() => {
        dispatch("snackbar/successMessage", `Successfully uploaded image`, { root: true });
        dispatch("getStatePageContent", state.selectedState);
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },

  uploadCityPromoImage: ({ state, dispatch }, formData) => {
    return axios.post(`/locations/${state.selectedState}/${state.selectedCity}/images`, formData)
      .then(() => {
        dispatch("snackbar/successMessage", `Successfully uploaded image`, { root: true });
        dispatch("getCityPageContent");
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },

  handlePromoImgAltText: ({ commit }, altText) => {
    commit("updateImgAltText", altText);
  },

  clearPromoImgAltText: ({ commit }) => {
    commit("resetImgAltText");
  }
};

const mutations = {
  addToLoadingState: (state, message) => {
    state.loadingState.push(message);
  },
  removeFromLoadingState: (state, message) => {
    state.loadingState = state.loadingState.filter(loadingMessage => loadingMessage !== message);
  },
  getAllStatesSuccess: (state, response) => {
    const states = [];

    for (const stateKey in response.states) {
      states.push({
        text: response.states[stateKey],
        value: stateKey
      });
    }

    state.states = states;
  },

  getAllCitiesForStateSuccess: (state, response) => {
    const cities = [];

    for (const cityKey in response.cities) {
      cities.push({
        text: response.cities[cityKey],
        value: cityKey
      });
    }

    state.cities = cities;
  },

  setCurrentState: (state, value) => {
    state.selectedState = value;
  },

  setCurrentStatePageData: (state, payload) => {
    state.currentStatePage = payload;
  },

  setCurrentCity: (state, value) => {
    state.selectedCity = value;
  },

  setCurrentCityPageData: (state, payload) => {
    state.currentCityPage = payload;
  },

  clearCurrentStatePageContent: (state) => {
    state.currentStatePage = null;
  },

  clearCurrentCityPageContent: (state) => {
    state.currentCityPage = null;
  },
  resetImgAltText: (state) => {
    state.promoImgText = "";
  },
  updateImgAltText: (state, altText) => {
    state.promoImgText = altText;

    if (state.currentCityPage && state.currentCityPage.promo_image) {
      const cityPage = JSON.parse(state.currentCityPage.promo_image.content);
      cityPage.alt_text = altText;
      state.currentCityPage.promo_image.content = JSON.stringify(cityPage);
    } else if (state.currentStatePage && state.currentStatePage.promo_image) {
      const statePage = JSON.parse(state.currentStatePage.promo_image.content);
      statePage.alt_text = altText;
      state.currentStatePage.promo_image.content = JSON.stringify(statePage);
    }
  }
};

export default {
  state,
  actions,
  mutations
};
